import { render, staticRenderFns } from "./TopicParameter.vue?vue&type=template&id=ba03ac20&"
import script from "./TopicParameter.vue?vue&type=script&lang=ts&"
export * from "./TopicParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports